// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 330 ? "eldch-components" : chunkId) + "." + {"290":"d7ee7d51","330":"21f214b2"}[chunkId] + ".chunk.js";
};